import {
	PHARMACY_ALL_DISPENSE_LIST_DATA_REQUEST,
	PHARMACY_ALL_DISPENSE_LIST_DATA_SUCCESS,
	PHARMACY_ALL_DISPENSE_LIST_DATA_FAILURE

} from '../../../constants';

import {
	patient_medicine_list,
	patient_counselling,
	consent_submission_logs,
	pharmacy_drugbilling,
	prescription_dispense,
	dispense_memo,
	upload_prescription,
	pharmacy_reverse_deliveries,
	pharmacy_reverse_deliveries_pdf,
	sign_ai,
	pharmacy_assign_assistant_driver,
	pharmacy_driver_list
} from '../../../../networking/urlEndPoints'

import Axios from '../../../../networking/intraceptor'

export const pharmacyAllDispenseListDataRequest = (types) => ({
	type: PHARMACY_ALL_DISPENSE_LIST_DATA_REQUEST,
	types: types
});

export const pharmacyAllDispenseListDataSuccess = (user, types) => ({
	type: PHARMACY_ALL_DISPENSE_LIST_DATA_SUCCESS,
	payload: user,
	types: types
});

export const pharmacyAllDispenseListDataFailure = (error, types) => ({
	type: PHARMACY_ALL_DISPENSE_LIST_DATA_FAILURE,
	payload: error,
	types: types
})

export const fetchAllDispenseList = (url, type, page, search, date) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		let params
		try {
			if (type === 'pharmacy_driver_list') {

				params = {
					page: page,
					search: search,
					date: date
				}

			} else {
				params = {
					page: page,
					patient_name: search,
				}
			}
			const response = await Axios.get(`${url}`, { params: params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const fetchGetDriverSignatures = (date, id, setGetDriverSigns) => {

	return async (dispatch) => {
		setGetDriverSigns((prevStat) => ({ ...prevStat, loading: true, data: [], error: null }))
		try {
			const params = {
				date: date,
				driver_id: id,
			}
			const response = await Axios.get(`get-driver-signs`, { params: params })

			if (response?.status === 200) {
				setGetDriverSigns((prevStat) => ({ ...prevStat, loading: false, data: (response?.data?.data?.data || []), error: null }))
			}

			else {
				throw new Error(response);
			}

		} catch (error) {
			if (error?.response) {
				setGetDriverSigns((prevStat) => ({ ...prevStat, loading: false, data: [], error: error.response }))
			}
		}
	}
}

export const fetchDriverListCounts = (date, setDriverCounts) => {
	return async (dispatch) => {
		setDriverCounts((prevState) => ({ ...prevState, loading: true, data: [], error: null }))
		try {
			const params = { date: date }
			const response = await Axios.get(`pharmacy-driver-list-counts`, { params: params })

			if (response?.status === 200) {
				setDriverCounts((prevState) => ({ ...prevState, loading: false, data: (response?.data?.data?.data || []), error: null }))
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				setDriverCounts((prevState) => ({ ...prevState, loading: false, data: [], error: error.response }))
			}
		}
	}
}

export const assignAssistantDriver = (driverId, assistentDriver, date, search, page, setAssistantLoading) => {
	return async (dispatch) => {
		if (typeof setAssistantLoading === 'function') {
			setAssistantLoading((prev) => ({ ...prev, [driverId]: true }))
		}
		try {
			const response = await Axios.post(pharmacy_assign_assistant_driver, {
				driver_id: driverId,
				assistent_driver: assistentDriver ? 1 : 0
			})
			if (response?.status === 200) {
				// dispatch(fetchAllDispenseList(pharmacy_driver_list, 'pharmacy_driver_list', page, search, date))
				if (typeof setAssistantLoading === 'function') {
					setAssistantLoading((prev) => ({ ...prev, [driverId]: false }))
				}
			} else {
				throw new Error(response)
			}
		} catch (error) {
			if (typeof setAssistantLoading === 'function') {
				setAssistantLoading((prev) => ({ ...prev, [driverId]: false }))
			}
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, 'pharmacy_driver_list'))
			}
		}
	}
}


export const fetchPatientMedicineList = (patient_id, type) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.post(`${patient_medicine_list}`, {
				patient_id: patient_id,
				blister: true
			})

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}


export const FetchPatientCounsellingList = (params, type) => {
	return async (dispatch) => {

		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${patient_counselling}`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const FetchPatientUploadPrescriptionList = (params, type) => {
	return async (dispatch) => {

		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${patient_counselling}`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const fetchPatientDrugList = (patient_id, type) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.post(`${patient_medicine_list}`, {
				patient_id: patient_id,
			})

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

// -------------------------------Fetch Counsent Submission list-------------------

export const FetchCounsentSubmissionList = (params, type) => {
	return async (dispatch) => {

		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${consent_submission_logs}`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const FetchTodaysBillingList = (params, type) => {
	return async (dispatch) => {

		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${pharmacy_drugbilling}`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const FetchPrescriptionsList = (params, type) => {
	return async (dispatch) => {

		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${prescription_dispense}`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}
export const fetchMemo = (type, params) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${dispense_memo}`, {
				params
			})

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}



export const fetchUploadPrescription = (type, params) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${upload_prescription}`, {
				params
			})

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}



export const fetchReverseDeliveries = (type, params) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${pharmacy_reverse_deliveries}`, {
				params
			})

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

/**
 * Fetches reverse deliveries PDF. Pass same params as list API (search_date, rx_type, route, search, status).
 * Returns response with { success, data: base64String } for opening in new tab.
 */
export const fetchReverseDeliveriesPdf = (params) => {
	return async () => {
		try {
			const response = await Axios.get(`${pharmacy_reverse_deliveries_pdf}`, { params });
			return response;
		} catch (error) {
			throw error;
		}
	}
}

export const FetchTransferConsentSubmissions = (params, type) => {
	return async (dispatch) => {

		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`pharmacy-transfer-pconcent`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const fetchMedReviewLogs = (params, type) => {
	return async (dispatch) => {

		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`pharmacy-patient-soap-notes/get-medreview-logs`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const fetchSoapNotesLogs = (params, type) => {
	return async (dispatch) => {

		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`pharmacy-patient-soap-notes/get-soapnote-logs`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const fetchCombinedPatientLogs = (params, type) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`pharmacy-patient-soap-notes/get-combined-patient-logs`, { params })

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const fetchSignAPI = (type, params) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`${sign_ai}`, {
				params
			})

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const FetchPharmacyAccountabilityData = (type, params) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`getRxNumersBysearch`, {
				params
			})

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}

export const FetchViewAllPharmacistSignatures = (type, params) => {
	return async (dispatch) => {
		dispatch(pharmacyAllDispenseListDataRequest(type));
		try {
			const response = await Axios.get(`pharmacist-signature`, {
				params
			})

			if (response?.status === 200) {
				dispatch(pharmacyAllDispenseListDataSuccess(response?.data, type));
			} else {
				throw new Error(response);
			}
		} catch (error) {
			if (error?.response) {
				dispatch(pharmacyAllDispenseListDataFailure(error?.response, type));
			}
		}
	}
}